import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagWave = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23 14H30L28 20L30 26H17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 10H23V22H10",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 9V31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgFlagWave);
export default ForwardRef;
